import { useState, useEffect, useRef } from 'react';
import { useUser } from '@clerk/clerk-react';

const HUBSPOT_ID_TIMEOUT_MS = 30000;
const POLL_INTERVAL_MS = 1500;

export function useHubspotContactId() {
  const { user, isLoaded } = useUser();
  const [
    isWaiting,
    setIsWaiting,
  ] = useState(true);
  const [
    timedOut,
    setTimedOut,
  ] = useState(false);
  const isMounted = useRef(true);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (!isLoaded || !isMounted.current) return;

    const hubspotContactId = user?.publicMetadata?.hubspotContactId;
    if (hubspotContactId) {
      setIsWaiting(false);
      return;
    }

    const startTime = Date.now();
    const interval = setInterval(async () => {
      if (!isMounted.current) {
        clearInterval(interval);
        return;
      }

      await user?.reload();
      const newId = user?.publicMetadata?.hubspotContactId;
      if (newId) {
        setIsWaiting(false);
        clearInterval(interval);
      } else if (Date.now() - startTime > HUBSPOT_ID_TIMEOUT_MS) {
        setTimedOut(true);
        setIsWaiting(false);
        clearInterval(interval);
      }
    }, POLL_INTERVAL_MS);

    return () => clearInterval(interval);
  }, [
    isLoaded,
    user,
  ]);

  return {
    hubspotContactId: user?.publicMetadata?.hubspotContactId,
    isWaiting,
    timedOut,
  };
}
